import { render } from "./ExternalMenu.vue?vue&type=template&id=c23422da&scoped=true"
import script from "./ExternalMenu.vue?vue&type=script&lang=js"
export * from "./ExternalMenu.vue?vue&type=script&lang=js"

import "./ExternalMenu.vue?vue&type=style&index=0&id=c23422da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c23422da"

export default script